import clsx from "clsx"

interface LabeledSectionProps extends React.PropsWithChildren {
    label?: string
    disabled?: boolean
    className?: string

    leftIcon?: React.ReactNode
    rightIcon?: React.ReactNode
}

export const LabeledSection: React.FC<LabeledSectionProps> = (props) => {
    const { label, disabled, className, leftIcon, rightIcon, children } = props

    return (
        <div
            className={clsx(
                'flex flex-col gap-2',
                disabled && 'opacity-30 pointer-events-none cursor-not-allowed',
                className
            )}
        >
            <div
                className={clsx(
                    "flex items-center xl:gap-4 gap-2",
                )}
            >
                {leftIcon}
                <p
                    className={clsx(
                        'font-bold text-cs-900',
                    )}
                >
                    {label}
                </p>
                {rightIcon}
            </div>
            {children}
        </div>
    )
}